module.exports = __webpack_public_path__ + "static/img/082.6f2e4bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/082.png
// module id = FrLN
// module chunks = 0